import type { Cart } from "@/lib/api";
import { suggestAccessories } from "@/lib/cart-suggestions";
import { LiveProductCard, useProducts } from "./CatalogProducts";

/**
 * "Lengkapi setup kamu": accessories the customer might add, under the cart.
 * Each card has quick add, so adding one never leaves the cart. Renders
 * nothing until the catalogue loads, or when there's nothing to suggest.
 */
export function CartSuggestions({ cart }: { cart: Cart | null }) {
  const { products } = useProducts();
  const picks = suggestAccessories(products, cart);
  if (picks.length === 0) return null;
  return (
    <section aria-labelledby="cart-suggestions" className="mt-16">
      <h2 id="cart-suggestions" className="text-2xl font-medium tracking-tight text-ink">
        Lengkapi setup kamu
      </h2>
      <p className="mt-1 text-sm text-ink/60">Aksesori yang sering dibeli bersama meja Kanata.</p>
      <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {picks.map((p) => (
          <LiveProductCard key={p.id} product={p} />
        ))}
      </div>
    </section>
  );
}
